import { render, staticRenderFns } from "./CounterpartiesGroup.vue?vue&type=template&id=00535538&"
import script from "./CounterpartiesGroup.vue?vue&type=script&lang=js&"
export * from "./CounterpartiesGroup.vue?vue&type=script&lang=js&"
import style0 from "./CounterpartiesGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports